import { types, getParent, applySnapshot, flow } from 'mobx-state-tree';
import { BillingCodeDetail } from './models';

const BillingCodeStore = types
  .model('BillingCodeStore', {
    billingCode: types.optional(BillingCodeDetail, {}),
  })
  .volatile(self => ({
    loading: false,
    submitting: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    setBillingCode(billingCode) {
      applySnapshot(self.billingCode, billingCode);
    },
    loadBillingCode: flow(function* (id) {
      try {
        self.loading = true;
        self.setBillingCode({});
        const response = yield self.root.api.billingCode.show(id);
        self.setBillingCode(response.data.data);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    submit: flow(function* (e, billingCodeId) {
      e && e.preventDefault && e.preventDefault();

      let response;
      try {
        self.submitting = true;
        if (billingCodeId != 0) {
          response = yield self.root.api.billingCode.update(self.billingCode.id, self.billingCode);
        }
        else {
          response = yield self.root.api.billingCode.store(self.billingCode);
        }
        self.setBillingCode(self.billingCode);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.submitting = false;

      return response;
    }),
  }))


export default BillingCodeStore;
